// extracted by mini-css-extract-plugin
export var blue = "_24-g";
export var brand = "_24-c";
export var darkGrey = "_24-f";
export var disabled = "_24-6";
export var disabledSubtle = "_24-7";
export var error = "_24-8";
export var green = "_24-h";
export var grey = "_24-e";
export var icon = "_24-0";
export var inherit = "_24-b";
export var lightGrey = "_24-d";
export var orange = "_24-j";
export var pink = "_24-l";
export var primary = "_24-1";
export var purple = "_24-m";
export var quaternary = "_24-4";
export var quinary = "_24-5";
export var red = "_24-k";
export var secondary = "_24-2";
export var success = "_24-a";
export var tertiary = "_24-3";
export var warning = "_24-9";
export var white = "_24-n";
export var yellow = "_24-i";